"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EEventsHistoryServices = exports.EEventsHistoryTypes = void 0;
var EEventsHistoryTypes;
(function (EEventsHistoryTypes) {
    EEventsHistoryTypes["created"] = "created";
    EEventsHistoryTypes["updated"] = "updated";
    EEventsHistoryTypes["removed"] = "removed";
})(EEventsHistoryTypes || (exports.EEventsHistoryTypes = EEventsHistoryTypes = {}));
var EEventsHistoryServices;
(function (EEventsHistoryServices) {
    EEventsHistoryServices["contactLists"] = "contactLists";
    EEventsHistoryServices["patterns"] = "patterns";
    EEventsHistoryServices["providers"] = "providers";
    EEventsHistoryServices["providerGroups"] = "providerGroups";
    EEventsHistoryServices["routingRules"] = "routingRules";
    EEventsHistoryServices["routingGroups"] = "routingGroups";
    EEventsHistoryServices["sendernames"] = "sendernames";
    EEventsHistoryServices["tariffs"] = "tariffs";
    EEventsHistoryServices["tasks"] = "tasks";
    EEventsHistoryServices["templates"] = "templates";
    EEventsHistoryServices["users"] = "users";
    EEventsHistoryServices["billingsUsers"] = "billingsUsers";
    EEventsHistoryServices["contactListsContacts"] = "contactListsContacts";
})(EEventsHistoryServices || (exports.EEventsHistoryServices = EEventsHistoryServices = {}));
//# sourceMappingURL=EventsHistory.js.map